import { Module } from 'vuex'
// import { Map, Stack } from "immutable"; //
import { DEFAULT_LIMIT, DEFAULT_PAGE } from '~/lib/api'
import { actionWrapper } from '~/lib/utils'
import { RootState } from '~/store'
// import { ProfileModules } from "@/store/profile";
// import {
//     commonProfileGetters,
//     commontSortComparator,
//     // mergeStacks,
//     parseRawDeposits,
//     parseRawDepositsByAllPairs,
// } from "@/store/profile/helpers";
import { DepositModel } from '~/lib/data-models/deposits/DepositModel'

export type DepositsMap = { [key in Ticker]: DepositWithdrawEntry[] };

// export type DepositsMap = Map<Ticker, Stack<DepositWithdrawEntry>>;

export interface DepositState {

  allEntries: DepositWithdrawEntry[];
  fetchedAllCount: number;
  showLoadMore: boolean
}

const DepositModule: Module<DepositState, RootState> = {
  namespaced: true,
  state: () => ({
    allEntries: [],
    fetchedAllCount: 0,
    showLoadMore: false,
  }),
  mutations: {
    setDeposites (state: DepositState, pld: { formatedRecords: DepositWithdrawEntry[], nextPage: boolean }) {
      state.allEntries = pld.formatedRecords
      state.showLoadMore = !!pld.nextPage
    },

    addDeposites (state: DepositState, pld: { formatedRecords: DepositWithdrawEntry[], nextPage: boolean }) {
      state.allEntries = [...state.allEntries, ...pld.formatedRecords]
      state.showLoadMore = !!pld.nextPage
    },
  },
  getters: {},
  actions: {
    fetchAllDeposits (...args) {
      return actionWrapper({
        beforeRequestHandler: ({ payload }) => {
          payload.offset = (payload.page - 1) * DEFAULT_LIMIT
        },
        apiRequest: ({ offset }) => this.$api.getDeposits({
          offset,
          limit: DEFAULT_LIMIT,
          // ...params,
        }),
        mutationName: '',
        successHandler: ({ context: { commit }, response: { response }, payload: { page } }) => {
          const { records, total, limit } = response

          const formatedRecords = records.length ? records.map(deposit => new DepositModel(deposit)) : []

          const nextPage = Math.ceil(total / limit) > page

          if (page > 1) {
            commit('addDeposites', { formatedRecords, nextPage })
          } else {
            commit('setDeposites', { formatedRecords, nextPage })
          }
        },
      }).bind(this)(...args)
    },
    fetchDepositsByTicker (...args) {
      return actionWrapper({
        beforeRequestHandler: ({ payload }) => {
          payload.limit = payload.limit || DEFAULT_LIMIT
          payload.page = payload.page || DEFAULT_PAGE
          payload.offset = (payload.page - 1) * payload.limit
        },
        apiRequest: ({ offset, ticker, limit }) => this.$api.getDepositsByTicker({
          ticker,
          offset,
          limit,
        }),
        mutationName: '',
        successHandler: ({ context: { commit }, response: { response }, payload: { page } }) => {
          const { records, total, limit } = response

          const formatedRecords = records.length ? records.map(deposit => new DepositModel(deposit)) : []

          const nextPage = Math.ceil(total / limit) > page

          if (page > 1) {
            commit('addDeposites', { formatedRecords, nextPage })
          } else {
            commit('setDeposites', { formatedRecords, nextPage })
          }
        },
      }).bind(this)(...args)
    },
  },
}

export default DepositModule
